export default {
      id: "contacts_cusrv-usage",
      viewBox: "0 0 72 61",
      url: __webpack_public_path__ + "sprite.svg#contacts_cusrv",
      toString: function () {
        return this.url;
      }
    }